import { render } from "./ImageLabel.vue?vue&type=template&id=4674e6b0&ts=true&lang=pug"
import script from "./ImageLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageLabel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__